export default function Logo() {
  return (
    <div className="relative h-[38px] w-[38px]">
      <div className="absolute left-[15%] h-[33%] w-[20%] origin-bottom-right animate-bop-left rounded-bl-[100%] rounded-tr-[100%] bg-green-400 shadow-inner"></div>
      <div className="absolute left-[41%] h-[33%] w-[20%] origin-bottom-left animate-bop-right rounded-br-[95%] rounded-tl-[88%] bg-green-600 shadow-inner"></div>
      <div className='absolute left-[38%] top-[33%] h-[40%] w-[7%] rotate-[-10deg] rounded-[50%] bg-green-900 before:absolute before:left-[-30%]  before:top-[0px] before:h-[100%] before:w-[100%] before:rotate-[2deg] before:rounded-[50%] before:bg-amber-50 before:content-[""]'></div>
    </div>
  )
}
